import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import axiosInstance from '../components/axios';

// Resources
import logo from '../images/logo.png';

// MaterialUI
// import { makeStyles } from '@mui/styles';
import AppBar from '@mui/material/AppBar';
import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import ListItemIcon from '@mui/material/ListItemIcon';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

// MaterialUI Icons
import MenuIcon from '@mui/icons-material/Menu';
import HomeIcon from '@mui/icons-material/Home';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import PersonPinCircleIcon from '@mui/icons-material/PersonPinCircle';
import Logout from '@mui/icons-material/Logout';
import UserPrefsManager from './user_prefs';
// import NotificationsIcon from '@mui/icons-material/Notifications';

function Header(props) {
	const { title, drawerIcon, onDrawerToggle } = props;
	const navigate = useNavigate();

	// const classes = useStyles();
	const [showMenu, setShowMenu] = useState(null);

	const [userInfo, setUserInfo] = useState({});

	useEffect(() => {
		axiosInstance.get(`/users/`).then(response => {
			setUserInfo(response.data);

			if (response.data) {
				// Set the user's timezone preference in local storage
				const tz = UserPrefsManager.get('userTimeZone');
				if (tz === null && response.data.time_zone) {
					UserPrefsManager.set('userTimeZone', response.data.time_zone);
				}
				
				// Set the user's measurement units preference in local storage
				const units = UserPrefsManager.get('userMeasUnits');
				if (units === null) {
					UserPrefsManager.set('userMeasUnits', (response.data.metric ? 'metric' : 'imperial'));
				}
				
				// If the user has to reset their password, redirect them to the password reset dialog
				if (response.data.password_reset) {
					navigate('/profile?passreset=true', { replace: true });
				}
			}
		});
	}, []);
  
	const handleAvatarClick = event => {
	  setShowMenu(event.currentTarget);
	};
  
	const handleClose = () => {
	  setShowMenu(null);
	};

	return (
		<React.Fragment>
			<AppBar
				color="primary"
				position="sticky"
				top={0}
				width="100%"
				sx={{
					zIndex: (theme) => theme.zIndex.drawer + 1,
					background: {
						md: 'linear-gradient(115deg, #0F1820 255px, #B1282E 300px)',
						xs: 'linear-gradient(115deg, #0F1820 85px, #B1282E 120px)'
					}
				}}
			>
				<Toolbar>
					<Grid container spacing={1} alignItems="center">
						<Grid sx={{ display: { md: 'block', xs: 'none' } }} item >
							<a href="/list"><img src={logo} alt="BTECH, Inc." style={{ height: "56px" }} /></a>
						</Grid>
						{ drawerIcon ? (
							<Grid sx={{ display: { md: 'none', sm: 'block' } }} item>
								<IconButton
									color="inherit"
									aria-label="open drawer"
									onClick={onDrawerToggle}
									edge="start"
								>
									<MenuIcon />
								</IconButton>
							</Grid>
						) : null }
						<Grid item xs alignItems="center">
							<Typography
								align="center"
								variant="h6"
								fontFamily='Saira,sans-serif'
								fontWeight='400'
								sx={{ flexGrow: 1}}
							>
								{title}
							</Typography>
						</Grid>
						<Grid item>
							<Tooltip title="Account settings">
							<IconButton
								aria-label="current user"
								aria-controls="menu-appbar"
								aria-haspopup="true"
								onClick={handleAvatarClick}
								color="inherit"
								sx={{ p: 0.5 }}
							>
								{(userInfo && userInfo.first_name && userInfo.last_name) ? (
									(() => {
										const initials = `${(userInfo.first_name[0] || '')}${(userInfo.last_name[0] || '')}`.toUpperCase();
										return (
											<Avatar style={{ backgroundColor: 'green' }}>
												<Typography fontFamily='Saira, sans-serif' variant="h6" style={{ fontWeight: 600 }}>{initials}</Typography>
											</Avatar>
										);
									})()
								) : (
									<Avatar style={{ backgroundColor: 'green' }} />
								)}
							</IconButton>
							</Tooltip>
						</Grid>
						<Menu
							id="menu-appbar"
							anchorEl={showMenu}
							keepMounted
							open={Boolean(showMenu)}
							onClose={handleClose}
							PaperProps={{
								elevation: 5,
								sx: {
									overflow: 'visible',
									filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
									mt: 1.0,
									'& .MuiAvatar-root': {
										width: 32,
										height: 32,
										ml: -.5,
										mr: 1,
									},
									'&:before': {
										content: '""',
										display: 'block',
										position: 'absolute',
										top: 0,
										right: 20,
										width: 10,
										height: 10,
										bgcolor: 'background.paper',
										transform: 'translateY(-50%) rotate(45deg)',
										zIndex: 0,
									},
								},
							}}
							anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
							transformOrigin={{ vertical: 'top', horizontal: 'right' }}

						>
							{userInfo && 
								<>
									<MenuItem
										disabled
										style={{
											fontWeight: 'bold',
											backgroundColor: 'lightgray',
											marginBlock: -8,
											color: 'black'
										}}
									>
										{ userInfo.email }
									</MenuItem>
									<Divider />
								</>
							}
							{userInfo && (userInfo.is_superuser || userInfo.is_staff) &&
								<>
									<MenuItem
										disabled
										style={{
											fontWeight: 'bold',
											marginBlock: -12,
											justifyContent: 'center'
										}}
									>
										<Typography fontSize="small" fontWeight='600'>
											{ userInfo.is_superuser ? "Superuser" : "Administrator"}
										</Typography>
									</MenuItem>
									<Divider />
								</>
							}
							<MenuItem
								onClick={handleClose}
								component="a"
								href="/list"
							>
								<ListItemIcon><HomeIcon /></ListItemIcon>
								Home
							</MenuItem>
							<Divider />
							<MenuItem
								onClick={handleClose}
								component="a"
								href="/profile"
							>
								<ListItemIcon>
									<AccountBoxIcon />
								</ListItemIcon>
								Profile
							</MenuItem>
							{ userInfo && (userInfo.is_superuser || userInfo.is_staff) && 
								<MenuItem
									onClick={handleClose}
									component="a"
									href="/admin/users"
								>
									<ListItemIcon>
										<ManageAccountsIcon />
									</ListItemIcon>
									Manage Users
								</MenuItem>
							}
							{ userInfo && (userInfo.is_superuser || userInfo.is_staff) && 
								<MenuItem
									onClick={handleClose}
									component="a"
									href="/admin/locations"
								>
									<ListItemIcon>
										<PersonPinCircleIcon />
									</ListItemIcon>
									Manage Locations
								</MenuItem>
							}
							<Divider />
							<MenuItem
								onClick={handleClose}
								component="a"
								href="/logout"
							>
								<ListItemIcon>
									<Logout />
								</ListItemIcon>
								Logout
							</MenuItem>
						</Menu>
					</Grid>
				</Toolbar>
			</AppBar>
			{/* <Toolbar /> */}
		</React.Fragment>
	);
}

Header.propTypes = {
	onDrawerToggle: PropTypes.func.isRequired,
};

export default Header;